module.exports = __webpack_public_path__ + "media/admin/csclip_logo-68cb77b2.png";